<div class="zentra-admin-success-dialog">
  <h1 mat-dialog-title>Subscription Status</h1>
  <div mat-dialog-content class="message">
    <h2>Delete Subscription?</h2>
  </div>
  <div mat-dialog-actions class="actions">
    <button
      color="primary"
      routerLink="/zentra-subscriptions"
      mat-flat-button
      mat-dialog-close
      (click)="cancelDelete()"
    >
      No - Go Back
    </button>
    <button
      color="primary"
      routerLink="/zentra-subscriptions"
      mat-flat-button
      mat-dialog-close
      (click)="confirmDelete()"
    >
      Yes - Delete
    </button>
  </div>
</div>
